<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'ResourcesDataProvider',
    props: {
		processId: {
            type: String,
            default: '0'
		},
		processStepId: {
            type: String,
            default: '0'
		},
	},
	data: () => ({
		showCreate: false,
	}),
	computed: mapGetters('processes', {
		resources: 'resources'
	}),
	methods: {
		createResource(resource) {
			this.$store.dispatch('processes/createProcessStepResource', {
				processId: this.processId,
				resource: resource,
			}).then(() => {
				this.setShowCreate(false);
			});
		},
		deleteResource(resourceId) {
			this.$store.dispatch('processes/deleteProcessStepResource', {
				processId: this.processId,
				processStepId: this.processStepId,
				resourceId: resourceId,
			});
		},
		editResource({resourceId, description, responsible, archive, archivePeriod}) {
            this.$store.dispatch('processes/editProcessStepResource', {
				processId: this.processId,
				processStepId: this.processStepId,
                resourceId: resourceId,
                description: description,
				responsible: responsible,
				archive: archive,
				archivePeriod: archivePeriod,
            });
		},
		setShowCreate(value) {
			this.showCreate = value;
		},
		sortResources({id, sortIndex }){
            this.$store.dispatch('processes/sortProcessStepResources', {
				processId: this.processId,
				id: id,
				processStepId: this.processStepId,
                sortIndex: sortIndex,
            });
		},
	},
	render () {
		if (!this.$scopedSlots.default) {
			return;
		}
	
		const slotScope = {
			resources: this.resources(this.processId, this.processStepId),
			createResource: this.createResource,
			editResource: this.editResource,
			deleteResource: this.deleteResource,
			showCreate: this.showCreate,
			setShowCreate: this.setShowCreate,
			sortResources: this.sortResources,
		};
				
		return this.$scopedSlots.default(slotScope);
	}
}
</script>